<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-links">
        <router-link to="/privacy-policy">Privacy Policy</router-link> | 
        <router-link to="/terms-of-service">Terms of Service</router-link>
      </div>
      <div class="copyright">
        © {{ currentYear }} Studio 308 LLC. All rights reserved.
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AppFooter',
  computed: {
    currentYear(): number {
      return new Date().getFullYear();
    }
  }
});
</script>

<style scoped>
.footer {
  width: 100%;
  margin-top: 2rem;
  padding: 1rem 0;
  border-top: 1px solid rgba(255, 253, 249, 0.1);
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.footer-links {
  margin-bottom: 0.75rem;
}

.footer-links a {
  color: #FFFDF9;
  text-decoration: none;
  margin: 0 0.5rem;
  font-size: 0.9rem;
  transition: opacity 0.2s ease;
}

.footer-links a:hover {
  opacity: 0.8;
  text-decoration: underline;
}

.copyright {
  font-size: 0.8rem;
  opacity: 0.8;
}
</style> 